const prefix = 'entity-filter-registry';

export const registryI18n = {
    statusHeader: { id: `${prefix}.statusHeader`, defaultMessage: 'Status' },
    typeHeader: { id: `${prefix}.typeHeader`, defaultMessage: 'Type' },
    ownerHeader: { id: `${prefix}.ownerHeader`, defaultMessage: 'Owner' },
    accessHeader: { id: `${prefix}.accessHeader`, defaultMessage: 'Access' },
    productCodeHeader: { id: `${prefix}.productCodeHeader`, defaultMessage: 'Product code' },
    productNameHeader: { id: `${prefix}.productNameHeader`, defaultMessage: 'Product name' },
} as const;
